import { LoanPageType, LoanGridType } from '../LoanConstants';

export const getGridTypeForPageType = (pageType: LoanPageType) => {
    switch (pageType) {
        case LoanPageType.Construction:
            return LoanGridType.Construction;
        case LoanPageType.Rental:
            return LoanGridType.Rental;
        case LoanPageType.BuildRent:
            return LoanGridType.BuildRent;
        case LoanPageType.Model:
            return LoanGridType.Model;
        case LoanPageType.Land:
            return LoanGridType.Land;
        case LoanPageType.FixFlip:
            return LoanGridType.FixFlip;
        case LoanPageType.Bridge:
            return LoanGridType.Bridge;
        default:
            return null;
    }
};
